import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurableMode } from './ConfigurableMode';
import { useUserDormitory } from '@/hooks/app';
import { SwiperItemAttrs } from '../../SwiperConfigable';

export default function DormitoryMode() {

  const [t] = useTranslation(['common', 'dormitory']);
  const { dormitory, fetchUserDormitory, loading, error } = useUserDormitory();

  useEffect(() => {
    fetchUserDormitory();
  }, []);

  const items: SwiperItemAttrs[] = (!dormitory || Object.keys(dormitory).length === 0) ? [] : [{
    id: dormitory?.id,
    title: `${t('dormitory:labels.dormitory')} ${dormitory?.dormitoryRoom?.dormitory?.name ?? t('common:labels.unknown')}`,
    subTitle: `${t('dormitory:labels.block')}: ${dormitory?.dormitoryBlock.name  ?? t('common:labels.unknown')}`,
    secondaryDescription: `${t('dormitory:labels.floor')}: ${dormitory?.dormitoryRoom?.dormitoryFloor?.name  ?? t('common:labels.unknown')}`,
    description: `${t('dormitory:labels.room')} ${dormitory?.dormitoryRoom?.code  ?? t('common:labels.unknown')}`
  }];

  return (
    <ConfigurableMode
      items={items}
      error={error}
      loading={loading}
      variant="dormitory"
      onActionClick={() => { }}
    />
  );
}
